module.exports = __webpack_public_path__ + "assets/img/usp-2.451b46d0.svg";